
export const MesheTypes: Record<GeometryTypes, GeometryTypes> = {
    box: "box",
    cylinder: "cylinder",
    cone: "cone",
    sphere: "sphere",
    plane: "plane",
    torus: "torus",
    torusknot: "torusknot",
    circle: "circle",
    ring: "ring",
    icosahedron: "icosahedron"
} as const;